export const SECONDS_TO_MS = 1_000;
export const MINUTES_TO_MS = 60 * SECONDS_TO_MS;
export const HOURS_TO_MS = 60 * MINUTES_TO_MS;
export const DAYS_TO_MS = 24 * HOURS_TO_MS;
